import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import { ScanHistory } from '../../../../interfaces/asm/models';
import { AsmService } from '../../../../services/asm/asm.service';
import { LowerCasePipe, UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-target-information',
    standalone: true,
    imports: [
        MatCardModule,
        MatTabsModule,
        MatTooltipModule,
        TranslocoModule,
        LowerCasePipe,
        UpperCasePipe,
    ],
    templateUrl: './target-information.component.html',
    styleUrl: './target-information.component.scss',
})
export class TargetInformationComponent {
    // isToggled
    isToggled = false;

    @Input() scan: ScanHistory;

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // changeData
    changeData() {}
}
